module.exports = __webpack_public_path__ + "7ef20a00.svg";